import React, { useState } from "react";
import { FiPlus, FiMinus } from "react-icons/fi";
import { categoryList } from "../../assets/data/categorydata";
import { Link } from 'react-router-dom';
import Coupon from '../../assets/images/banners/coupon.jpg'

const SidebarCategory = () => {
  const [clicked, setClicked] = useState(false);

  const toggle = (index) => {
    if (clicked === index) {
      //if clicked question is already active, then close it
      return setClicked(null);
    }

    setClicked(index);
  };
  return (
    <>
      <div className="sidebarCategory">
        {/* <img src={Coupon} alt="Coupon Card"  className="img-fluid"/> */}
        {/* <div className="sidebar-top">
          <h2 className="sidebar-title">category</h2>
        </div> */}

        {/* <ul className="sidebar-menu-category-list">
          {categoryList.map((item, index) => {
            return (
              <>
                <li className="sidebar-menu-category" key={index}>
                  <button
                    className="sidebar-accordion-menu"
                    onClick={() => toggle(index)}
                    key={index}
                  >
                    <div className="menu-title-flex">
                      <img
                        src={item.image}
                        alt="clothes"
                        width="20"
                        height="20"
                        className="menu-title-img"
                      />

                      <p className="menu-title">{item.catname}</p>
                    </div>

                    <div>
                      <span>
                        {clicked === index ? (
                          <FiMinus className="cat-icon" />
                        ) : (
                          <FiPlus className="cat-icon" />
                        )}
                      </span>
                    </div>
                  </button>

                  {clicked === index ? (
                    <ul className="sidebar-submenu-category-list">
                      {item.subcategory.map((subcat, index) => {
                        return (
                          <>
                            <li className="sidebar-submenu-category" key={index}>
                              <Link to="/" className="sidebar-submenu-title">
                                <p className="product-name">
                                  {subcat.subcatname}
                                </p>
                                <p
                                  className="stock"
                                >
                                  {subcat.value}
                                </p>
                              </Link>
                            </li>
                          </>
                        );
                      })}
                    </ul>
                  ) : null}
                </li>
              </>
            );
          })}
        </ul> */}
      </div>
    </>
  );
};

export default SidebarCategory;
